import React from "react";
import { ReportFilters } from "@common/types/filters/reports";
import { Button } from "@design-system/Button/Button";
import { DownloadIcon } from "@icons";
import { useCashFlowReportDownload } from "./useCashFlowReportDownload";

interface CashFlowExportButtonProps {
    filters: ReportFilters;
}

export const CashFlowExportButton: React.FC<CashFlowExportButtonProps> = ({
    filters,
}) => {
    const { download, isDownloading } = useCashFlowReportDownload(filters);

    return (
        <Button
            variant="primary"
            size="md"
            iconOnly
            aria-label="Export cash flow report"
            disabled={isDownloading}
            onClick={() => download()}
        >
            <DownloadIcon />
        </Button>
    );
};
